import { __ } from '@wordpress/i18n';
import { registerBlockType } from '@wordpress/blocks';
import { useBlockProps, InspectorControls } from '@wordpress/block-editor';
import { PanelBody, SelectControl, ToggleControl } from '@wordpress/components';
import { useState } from '@wordpress/element';
import ServerSideRender from '@wordpress/server-side-render';
import './style.scss';
import './editor.scss';

registerBlockType('kanews/calculator', {
  title: __('Hesaplayıcılar', 'kanews'),
  icon: 'calculator',
  category: 'kanews',
  attributes: {
      type: {
          type: 'string',
          default: 'doviz'
      },
      showTabs: {
          type: 'boolean',
          default: false
      },
      excludedTypes: {
          type: 'array',
          default: []
      },
      index: {
          type: 'string',
          default: ''
      }
  },
  supports: {
      html: false,
      align: ['wide', 'full']
  },
  edit: function Edit({ attributes, setAttributes }) {
    const blockProps = useBlockProps();
    const [activeTab, setActiveTab] = useState(attributes.type);

    const calculatorTypes = [
        { label: __('Döviz', 'kanews'), value: 'doviz' },
        { label: __('Kripto', 'kanews'), value: 'coin' },
        { label: __('Emtia', 'kanews'), value: 'emtia' },
        { label: __('Burç', 'kanews'), value: 'burc' },
        { label: __('VKİ', 'kanews'), value: 'vki' },
        { label: __('Kredi', 'kanews'), value: 'kredi' },
        { label: __('Birikim', 'kanews'), value: 'birikim' }
    ];

    const filteredTypes = calculatorTypes.filter(type => 
        !attributes.excludedTypes.includes(type.value)
    );

    return (
        <>
            <InspectorControls>
                <PanelBody title={__('Hesaplayıcı Ayarları', 'kanews')}>
                    <SelectControl
                        label={__('Hesaplayıcı Tipi', 'kanews')}
                        value={attributes.type}
                        options={filteredTypes}
                        onChange={(value) => setAttributes({ type: value })}
                    />
                    <ToggleControl
                        label={__('Seçenekleri Göster', 'kanews')}
                        checked={attributes.showTabs}
                        onChange={(value) => setAttributes({ showTabs: value })}
                    />
                </PanelBody>
            </InspectorControls>
            <div {...blockProps}>
                <ServerSideRender
                    block="kanews/calculator"
                    attributes={{
                        type: attributes.type,
                        showTabs: attributes.showTabs,
                        excludedTypes: attributes.excludedTypes,
                        index: attributes.index
                    }}
                />
            </div>
        </>
    );
  },
  save: function Save() {
    return null;
  }
});

